export default __webpack_public_path__ + "static/media/de.be987e76.svg";